import React, { useEffect } from "react";
import {
  Grid,
  TextField,
  Typography,
  Box,
  useTheme,
  MenuItem,
} from "@mui/material";

interface Props {
  config: any;
  onChange: (field: string, value: any) => void;
}

const ClickInsForm: React.FC<Props> = ({ config, onChange }) => {
  const theme = useTheme();
  const red = theme.palette.status.accent;

  // Always set clientInspectorName to BWIA - Akron
  useEffect(() => {
    onChange("clientInspectorName", "BWIA - Akron");
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderLeft: `3px solid ${red}`,
        borderRadius: 2,
        p: 2,
        mt: 1,
        boxShadow: "0 0 6px rgba(0,0,0,0.3)",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          mb: 2,
          fontWeight: 600,
          color: red,
          letterSpacing: 0.3,
        }}
      >
        Send to Click-Ins
      </Typography>

      <Grid container spacing={2}>
        {/* Image Type */}
        <Grid item xs={12} sm={6}>
          <TextField
            select
            label="Image Type"
            fullWidth
            value={config.imageType || ""}
            onChange={(e) => onChange("imageType", e.target.value)}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          >
            <MenuItem value="imageExterior">Raw Externals</MenuItem>
            <MenuItem value="imageManual">Manuals</MenuItem>
            <MenuItem value="imageCrop">Cropped</MenuItem>
          </TextField>
        </Grid>

        {/* Inspection Type */}
        <Grid item xs={12} sm={6}>
          <TextField
            label="Inspection Type"
            fullWidth
            value={config.inspectionType || ""}
            onChange={(e) => onChange("inspectionType", e.target.value)}
            placeholder="e.g. FULL_INSPECTION"
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        {/* Hidden auto field (clientInspectorName) */}
        <Grid item xs={12}>
          <TextField
            label="Client Inspector Name (auto-set)"
            fullWidth
            disabled
            value={config.clientInspectorName || "BWIA - Akron"}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
              },
              "& .MuiInputBase-input": { color: "#999" },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ClickInsForm;
